<template>
  <sweet-modal
    ref="modal"
    class="vld-parent"
    hide-close-button
    @close="closeModalCleanUp"
  >
    <template #title>
      <strong id="modal-title">Filter conditions</strong>
    </template>

    <display-conditions-container @condition-applied="closeModal" />
  </sweet-modal>
</template>

<script>
import {SweetModal} from 'sweet-modal-vue-3';
import {mapState, mapActions, mapMutations} from 'vuex';
import DisplayConditionsContainer from '../display-conditions/DisplayConditionsContainer';

export default {
  name: 'DisplayConditionsModal',
  components: {
    SweetModal,
    DisplayConditionsContainer
  },
  computed: {
    ...mapState({
      displayConditionsOpen: state => state.displayConditionsOpen,
      templateData: state => state.templateData,
      displayConditionSaved: state => state.displayConditionSaved
    })
  },
  methods: {
    ...mapActions('displayModule', [
      'retrieveDisplayConditions',
      'retrieveSourceFields'
    ]),
    ...mapActions(['rejectDisplayCondition']),
    ...mapMutations(['setDisplayConditionsOpen', 'setDisplayConditionSaved']),
    closeModalCleanUp() {
      this.setDisplayConditionsOpen(false);
      if (this.displayConditionSaved === false) {
        this.rejectDisplayCondition();
      }
    },
    closeModal() {
      this.$refs.modal.close();
    }
  },
  watch: {
    displayConditionsOpen(newValue) {
      if (newValue === true) {
        this.retrieveDisplayConditions({
          sourceId: this.templateData.mergeTagsSource.id
        });
        this.retrieveSourceFields({
          sourceId: this.templateData.mergeTagsSource.id
        });
        this.setDisplayConditionSaved(false);
        this.$refs.modal.open();
      }
    }
  }
};
</script>

<style scoped>
#modal-title {
  text-align: left;
}
</style>
